import { Component } from '@angular/core';
import { TopbarComponent } from "../../../core/components/app-topbar/topbar.component";
import { RouterOutlet } from '@angular/router';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-auth',
  imports: [TopbarComponent, RouterOutlet, DividerModule],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {

}
